import {stepToPage} from '../uiActions';

export default sectionName => (dispatch, getState) => {
  let sectionIndex = getState().ui.sections.findIndex(section => section === sectionName);
  if (sectionIndex === -1) {
    sectionIndex = 0;
  }
  // add one to index due to array indexing starting at 0
  dispatch(stepToPage(sectionIndex + 1));
};
